export default {"src":"/_next/static/media/hospital.377bf14d.svg","height":89,"width":90,"blurWidth":0,"blurHeight":0};